import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AppMenu from '../../components/AppMenu';
import AuthenticationNeeded from '@features/auth/AuthenticationNeeded.tsx';
import { useAuthentication } from '@/features/auth/useAuthentication';

const AppLayoutInner: React.FC = () => {
  const location = useLocation();
  const { loggedUser, authenticationDone, isGlobalAdmin } = useAuthentication();

  if (!authenticationDone || !loggedUser) {
    return null;
  }

  const salonId = loggedUser.accessRights?.salonId;
  if (location.pathname === '/app' && salonId && !isGlobalAdmin()) {
    return <Navigate to={`/app/${salonId}/calendar`} replace />;
  }

  return (
    <div className="max-h-screen min-h-screen flex">
      {/* Sidebar */}
      <AppMenu />

      {/* Main Content Area */}
      <main className="flex-1 max-h-screen min-h-screen ">
        <Outlet />
      </main>
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <AuthenticationNeeded>
      <AppLayoutInner />
    </AuthenticationNeeded>
  );
};

export default AppLayout;
